var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTryAgainDarkRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_2966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2887 8.694C13.1628 9.65397 12.7779 10.5616 12.1754 11.3194C11.5729 12.0773 10.7755 12.6569 9.86864 12.996C8.96178 13.3351 7.97972 13.421 7.02777 13.2444C6.07583 13.0678 5.18991 12.6354 4.46504 11.9935C3.74016 11.3517 3.20368 10.5247 2.91312 9.6011C2.62256 8.67754 2.58888 7.6923 2.8157 6.75106C3.04253 5.80981 3.52129 4.94807 4.20065 4.25824C4.88001 3.56841 5.73434 3.07652 6.672 2.83533C9.27133 2.16867 11.962 3.50667 12.9553 6",
    stroke: "#8B0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.66667V6H10",
    stroke: "#8B0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_2966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTryAgainDarkRed);
export default __webpack_public_path__ + "static/media/Icon_TryAgain_DarkRed.9881715b41e9781687831323d8815697.svg";
export { ForwardRef as ReactComponent };